<!-- TABLE EXCEL BUTTON -->        
<div class="buttonTablePDF custom-image-button"  (click)="onClick()">
  <img width="28" height="26" src="assets/icons/pdf.png" />
</div>